"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReversalsReport = void 0;
const moment = require("moment");
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const modal_1 = require("client/components/modal");
const store_1 = require("client/modules/reporting/store");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const mobx_1 = require("mobx");
const number_formatter_1 = require("../claim-analytics/number-formatter");
require("./reversals-report.less");
const reversals_header_1 = require("./components/reversals-header");
const transaction_details_1 = require("client/modules/orders/modules/orders-detail/components/order-claims/transaction-details"); // E-084
const button_1 = require("client/components/material/button");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const store_2 = require("client/modules/orders/store");
const JSZip = require("jszip"); // E-084
const file_saver_1 = require("file-saver"); // E-084
const ui_1 = require("../../../../../../../components/ui"); // E-084
const icons_1 = require("../../../../../../../components/icons"); // E-084
let ReversalsReport = class ReversalsReport extends React.Component {
    constructor(props) {
        super(props);
        this.progress = { current: 0, total: 0 };
        this.showQueryManager = true;
        this.erxLogData = []; // B-096.2
        this.loadingText = false; // B-096.2
        this.selectedRawData = []; // E-084
        this.selectedFinalData = []; // E-084
        this.onRetryCLaim = true; // E-084
        this.onGenerateZip = false; // E-084
        this.query = {
            end: new Date(),
            start: moment(new Date()).subtract(30, "days")
        };
        this.createHeaderButton = (text, onClick) => {
            const button = (React.createElement("button", { onClick: onClick, style: { marginLeft: "2em" }, type: "button" }, text));
            return button;
        };
        this.renderProgressBar = () => {
            const { current, total } = this.progress;
            const percent = (current / total) * 100;
            if (total !== 0) {
                return (React.createElement(modal_1.Modal, { width: "30%", top: "40%", onCancel: () => null },
                    React.createElement("div", { style: { textAlign: "center" } },
                        "Sending B2s (",
                        current,
                        "/",
                        total,
                        ")"),
                    React.createElement("div", { style: {
                            backgroundColor: "#FFF",
                            border: "1px solid black",
                            width: "100%"
                        } },
                        React.createElement("div", { style: {
                                backgroundColor: "rgb(19 34 68)",
                                height: "1.5em",
                                transition: "width .5s",
                                width: `${percent}%`
                            } }))));
            }
        };
        this.renderTransactionModal = () => {
            if (!this.transactionData)
                return;
            const { requests, responses, rxId, siteName: name, timezone } = this.transactionData;
            const missingProps = {
                order: { site: { name, timezone } },
                rxId: { rxId }
            };
            const selectedRow = Object.assign(Object.assign({}, this.transactionData), missingProps);
            selectedRow.requests = JSON.parse(requests);
            selectedRow.responses = JSON.parse(responses);
            return (React.createElement(transaction_details_1.TransactionDetails, { claim: selectedRow, erxLog: this.erxLogData, onCancel: () => {
                    this.transactionData = null;
                } }));
        };
        this.renderQueryModal = () => {
            if (this.showQueryManager) {
                const cancelButton = (React.createElement(button_1.MaterialButton, { style: { marginLeft: "1em" }, onClick: () => {
                        this.showQueryManager = false;
                    } }, "Cancel"));
                const submitButton = (React.createElement(button_1.MaterialButton, { disabled: !this.query.start || !this.query.end, onClick: async () => {
                        this.showQueryManager = false;
                        await store_1.reportsStore.loadReversalsReport(this.query);
                    }, primary: true }, "Submit"));
                const buttons = [submitButton, cancelButton];
                const modal = (React.createElement(modal_1.Modal, { buttons: buttons, onCancel: () => {
                        this.showQueryManager = false;
                    } },
                    React.createElement("div", { style: { display: "flex" } },
                        this.genDate("start"),
                        this.genDate("end"))));
                return modal;
            }
        };
        this.genDate = (type) => {
            const title = type.replace(/\b\w/g, c => c.toUpperCase());
            const jsx = (React.createElement("div", { style: { paddingRight: "1em" } },
                React.createElement("h3", null,
                    title,
                    " Date: "),
                React.createElement(date_picker_1.MaterialDatePicker, { label: `${title} Date`, required: true, value: this.query[type] || "", onChange: val => {
                        mobx_1.extendObservable(this.query, { [type]: val });
                    } }),
                React.createElement("div", { style: { display: "flex", marginTop: "1em" } },
                    React.createElement(button_1.MaterialButton, { primary: true, onClick: () => {
                            mobx_1.extendObservable(this.query, { [type]: new Date() });
                        }, style: { marginRight: "1em" } }, "Today"),
                    React.createElement(button_1.MaterialButton, { onClick: () => {
                            mobx_1.extendObservable(this.query, { [type]: null });
                        } }, "Clear"))));
            return jsx;
        };
        /**
         * get erx data while click on view claim data. B-096.2
         * function is used to get the each and every ERX tranmission date and time
         */
        this.getErxDataOnView = async (claimId) => {
            var _a;
            this.onRetryCLaim = false; // B-096.2
            let filteredData = [];
            const result = await store_2.ordersStore.readERXLog(claimId); //B-096.2
            const erxLogs = result.value; //B-096.2
            (_a = (erxLogs || [])) === null || _a === void 0 ? void 0 : _a.map((item) => {
                var _a;
                (_a = (erxLogs || [])) === null || _a === void 0 ? void 0 : _a.filter((data) => {
                    if (item.id === data.logReference) {
                        filteredData.push(item, data);
                    }
                });
            });
            this.erxLogData = filteredData || []; //B-096.2
            this.onRetryCLaim = true; // B-096.2
        };
        this.onRowClicked = async (row) => {
            const { data } = row;
            this.loadingText = true; // B-096.2
            this.getErxDataOnView(data.claimId); // B-096.2
            const transactionData = await store_2.ordersStore.loadTransactionData(data.claimId);
            this.transactionData = transactionData;
        };
        // C-128
        this.onButtonSendB2 = async () => {
            const selectedRows = this.storeData.gridApi.getSelectedRows();
            let rowsToSend;
            if (selectedRows.length > 0) {
                rowsToSend = selectedRows;
            }
            else {
                const filteredNodes = this.storeData.gridApi.getModel().rowsToDisplay;
                rowsToSend = filteredNodes.map((node) => node.data);
            }
            this.progress.total = rowsToSend.length;
            for (const row of rowsToSend) {
                this.progress.current++;
                await store_1.reportsStore.reportsB2(row.claimId, Boolean(row.isCopay));
            }
            this.progress = { current: 0, total: 0 };
        };
        // E-084
        this.onButtonExport = () => {
            let params = {};
            if (this.storeData.gridApi.getSelectedRows().length > 0) {
                params = {
                    fileName: " Reversals Report.csv",
                    onlySelected: this.storeData.gridApi.getSelectedRows() ? true : false
                };
            }
            else {
                params = {
                    fileName: " Reversals Report.csv"
                };
            }
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        /**
         * E-084 handle slection of claim data while click on row
         * @param row
         */
        this.onRowSelected = async (row) => {
            this.loadingText = false; // B-096.2
            let rowData = this.selectedRawData || [];
            const { data } = row;
            if (row.node.isSelected()) {
                if (!rowData.some((item) => item.claimId === data.claimId)) {
                    let raw = await store_2.ordersStore.loadTransactionData(data.claimId);
                    rowData.push(raw);
                }
            }
            else {
                rowData = rowData.filter((item) => item.claimId !== data.claimId);
            }
            this.selectedRawData = rowData;
        };
        /**
         * E-084 handle to format raw selected claim data
         * @returns
         */
        this.formateTheRawDataForPDFExport = () => {
            let data = [];
            if (!this.selectedRawData)
                return;
            for (let i = 0; i < this.selectedRawData.length; i++) {
                const { requests, responses, rxId, siteName: name, timezone } = this.selectedRawData[i];
                const missingProps = {
                    order: { site: { name, timezone } },
                    rxId: { rxId }
                };
                const selectedRow = Object.assign(Object.assign({}, this.selectedRawData[i]), missingProps);
                selectedRow.requests = JSON.parse(requests);
                selectedRow.responses = JSON.parse(responses);
                data.push(selectedRow);
            }
            this.selectedFinalData = data;
        };
        /**
         * E-084 handle to convert selected claim data to PDF
         */
        this.onClickPDFBtnHead = async () => {
            var _a, _b;
            const zip = new JSZip();
            const pdfPromises = [];
            // Reset the zip content to ensure new files are added
            this.storeZipContent = null; // Clear previous content
            if (this.selectedFinalData.length) {
                this.onRetryCLaim = false;
                const claimName = [];
                for (const claim of this.selectedFinalData) {
                    try {
                        const pdfDocGenerator = await transaction_details_1.transactionDetailsPdf(claim, "reversalErxReport");
                        claimName.push((_b = (_a = pdfDocGenerator === null || pdfDocGenerator === void 0 ? void 0 : pdfDocGenerator.docDefinition) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.title);
                        const pdfBlobPromise = new Promise((resolve, reject) => {
                            pdfDocGenerator.getBlob((blob) => {
                                if (blob) {
                                    resolve(blob);
                                }
                                else {
                                    reject(new Error("Failed to generate PDF blob"));
                                }
                            });
                        });
                        // Push the promise to the array
                        pdfPromises.push(pdfBlobPromise);
                    }
                    catch (error) {
                        console.error("Error generating PDF for claim:", error);
                    }
                }
                try {
                    // Await all PDF blobs
                    const pdfBlobs = await Promise.all(pdfPromises);
                    // Add each PDF blob to the zip
                    pdfBlobs.forEach((blob, index) => {
                        zip.file(`${claimName[index]}.pdf`, blob);
                    });
                    // Generate the zip file and trigger download
                    const content = await zip.generateAsync({ type: "blob" });
                    this.storeZipContent = content; // Store the new zip content
                }
                catch (error) {
                    alert("Something went wrong!!");
                    console.error("Error generating PDFs or ZIP:", error);
                    this.onRetryCLaim = true;
                }
                this.onRetryCLaim = true;
                this.onGenerateZip = true;
            }
            this.selectedRawData = []; // C-038.1
        };
        this.downloadZipFiles = async () => {
            if (this.storeZipContent) {
                file_saver_1.saveAs(this.storeZipContent, "ClaimsData.zip");
                this.selectedFinalData = []; // Clear selected data after download
                this.storeZipContent = null; // Reset the zip content
                this.onGenerateZip = false;
            }
            else {
                alert("No files to download.");
            }
        };
        this.storeData = {
            columnDefs: [
                {
                    headerCheckboxSelection: true,
                    checkboxSelection: true,
                    width: 80,
                    headerCheckboxSelectionFilteredOnly: true,
                },
                {
                    field: "date",
                    headerName: "Date of Service",
                    filter: "agDateColumnFilter",
                    sortable: true,
                    filterParams: {
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            if (!cellValue)
                                return -1;
                            const dateParts = cellValue.split("/");
                            if (dateParts.length !== 3)
                                return -1;
                            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                                return 0;
                            }
                            return cellDate < filterLocalDateAtMidnight ? -1 : 1;
                        },
                        browserDatePicker: true
                    },
                    comparator: (date1Str, date2Str) => {
                        if (!date1Str)
                            return -1;
                        if (!date2Str)
                            return 1;
                        const dateParts1 = date1Str.split("/");
                        const dateParts2 = date2Str.split("/");
                        const date1 = new Date(Number(dateParts1[2]), Number(dateParts1[0]) - 1, Number(dateParts1[1]));
                        const date2 = new Date(Number(dateParts2[2]), Number(dateParts2[0]) - 1, Number(dateParts2[1]));
                        return date1.getTime() - date2.getTime();
                    }
                },
                {
                    field: "rxId",
                    headerName: "Rx Number",
                    filter: "agTextColumnFilter",
                    sortable: true,
                    enableRowGroup: true,
                    comparator: (a, b) => {
                        return Number(a) - Number(b);
                    }
                },
                {
                    field: "orderId",
                    filter: "agTextColumnFilter",
                    headerName: "Order ID"
                },
                {
                    field: "siteName",
                    filter: "agTextColumnFilter",
                    headerName: "Pharmacy"
                },
                {
                    field: "status",
                    filter: "agNumberColumnFilter",
                    headerName: "Rx Status",
                    sortable: true,
                    valueGetter: (params) => {
                        if (params.data.status == "5dispensed")
                            return "Dispensed";
                        else if (params.data.status == "1error")
                            return "Error";
                        else if (params.data.status == "9intended")
                            return "Intended";
                        else if (params.data.status == "6new")
                            return "New";
                        else if (params.data.status == "4paid")
                            return "Approved";
                        else if (params.data.status == "0refill")
                            return "Dispensed";
                        else if (params.data.status == "0refillDelayed")
                            return "Dispensed";
                        else if (params.data.status == "8refillDone")
                            return "Dispensed";
                        else if (params.data.status == "7refilled")
                            return "Dispensed";
                        else if (params.data.status == "3reversed")
                            return "Reversed";
                        else if (params.data.status == "2reverseError")
                            return "Reverse Error";
                        else if (params.data.status == "2reverseErrorDev")
                            return "Reverse Error";
                        else
                            return params.data.status;
                    } // D-002.834
                },
                {
                    field: "payerName",
                    filter: "agTextColumnFilter",
                    headerName: "Payer"
                },
            ],
            defaultColDef: {
                comparator: (a, b) => typeof a === "string"
                    ? a.localeCompare(b)
                    : a > b
                        ? 1
                        : a < b
                            ? -1
                            : 0,
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                filter: true,
                resizable: true,
                sortable: true
            },
            floatingFilter: true,
            frameworkComponents: {
                numberFormatter: number_formatter_1.NumberFormatter
            },
            multiSortKey: "ctrl",
            rowData: [],
            rowSelection: "multiple"
        };
    }
    componentWillUnmount() {
        store_1.reportsStore.reversalsData = null;
    }
    render() {
        const buttons = [];
        const storeData = store_1.reportsStore.reversalsData;
        const shouldRender = (storeData === null || storeData === void 0 ? void 0 : storeData.length) > 0;
        this.storeData.rowData = storeData;
        const pushBtn = (btn) => buttons.push(btn);
        const mkBtn = (text, onClick) => pushBtn(this.createHeaderButton(text, onClick));
        mkBtn("Edit Search", () => {
            this.showQueryManager = true;
        });
        if (shouldRender) {
            mkBtn("Send B2s", this.onButtonSendB2);
            mkBtn("Reload Rows", async () => {
                store_1.reportsStore.reversalsData = null;
                await store_1.reportsStore.loadReversalsReport(this.query);
            });
        }
        const header = (React.createElement(reversals_header_1.ReversalsHeader, { buttons: buttons, title: "Reversals Report" }));
        // TMPP > Reporting - Add Export to CSV Option to Following Reports  Add 235 line
        // E-063
        // reversal Log
        // B-096.2
        if (!this.onRetryCLaim) {
            return (React.createElement("div", { style: { display: "float", marginLeft: "50%", marginTop: "10%" } },
                React.createElement(ui_1.UiLoadingIndicator, null),
                React.createElement("div", null, this.loadingText ? "Loading..." : "Generating PDF...")));
        } // E-084
        const agGrid = (React.createElement("div", { className: "ag-theme-balham", style: {
                height: "85%",
                width: "100%"
            } },
            React.createElement("div", { style: { display: 'flex' }, className: "" },
                React.createElement("button", { type: "button", onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
                React.createElement("div", { style: { display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: '37px', } },
                    React.createElement("button", { type: "button", onClick: !this.onGenerateZip
                            ? this.onClickPDFBtnHead.bind(this)
                            : this.downloadZipFiles.bind(this) }, !this.onGenerateZip ? "Export to PDF" : "Download Zip"),
                    this.onGenerateZip && React.createElement(icons_1.DownloadIcon, null))),
            React.createElement(ag_grid_react_1.AgGridReact, { animateRows: true, columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, floatingFilter: this.storeData.floatingFilter, frameworkComponents: this.storeData.frameworkComponents, groupMultiAutoColumn: true, multiSortKey: this.storeData.multiSortKey, onGridReady: params => {
                    this.storeData.gridApi = params.api;
                }, onRowClicked: this.onRowClicked, onRowSelected: this.onRowSelected, rowData: this.storeData.rowData, rowSelection: this.storeData.rowSelection, sideBar: true, suppressExcelExport: true, suppressRowClickSelection: true })));
        // E-084 {this.formateTheRawDataForPDFExport()}
        return (React.createElement(React.Fragment, null,
            header,
            React.createElement("br", null),
            store_1.reportsStore.showLoader ? React.createElement(React.Fragment, null) : agGrid,
            this.renderProgressBar(),
            this.renderTransactionModal(),
            this.formateTheRawDataForPDFExport(),
            this.renderQueryModal()));
    }
};
__decorate([
    mobx_1.observable
], ReversalsReport.prototype, "progress", void 0);
__decorate([
    mobx_1.observable
], ReversalsReport.prototype, "showQueryManager", void 0);
__decorate([
    mobx_1.observable
], ReversalsReport.prototype, "transactionData", void 0);
__decorate([
    mobx_1.observable
], ReversalsReport.prototype, "erxLogData", void 0);
__decorate([
    mobx_1.observable
], ReversalsReport.prototype, "loadingText", void 0);
__decorate([
    mobx_1.observable
], ReversalsReport.prototype, "selectedRawData", void 0);
__decorate([
    mobx_1.observable
], ReversalsReport.prototype, "selectedFinalData", void 0);
__decorate([
    mobx_1.observable
], ReversalsReport.prototype, "onRetryCLaim", void 0);
__decorate([
    mobx_1.observable
], ReversalsReport.prototype, "onGenerateZip", void 0);
__decorate([
    mobx_1.observable
], ReversalsReport.prototype, "storeZipContent", void 0);
__decorate([
    mobx_1.observable
], ReversalsReport.prototype, "query", void 0);
ReversalsReport = __decorate([
    mobx_react_1.observer
], ReversalsReport);
exports.ReversalsReport = ReversalsReport;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/reversals-report/reversals-report.tsx
// module id = 3967
// module chunks = 0